import { Component } from '@angular/core';
import { PageService } from '../pages/pages.service';
import { CMSPageListDTO } from '../pages/models/page-api-models';

@Component({
  selector: 'sca-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent {

  pages: CMSPageListDTO[] = [];
  categoryId = 1; // 🔁 Set dynamically or pass as @Input

  displayedColumns: string[] = ['name', 'title', 'sort', 'actions'];

  constructor(
    private pageService: PageService
  ) { }

  ngOnInit(): void {
    // this.scheduleService.getSchedule().subscribe((data) => {
    //   this.schedule = data;
    // });

    this.pageService.getPagesByCategory(this.categoryId).subscribe({
      next: data => this.pages = data,
      error: err => console.error('Error fetching pages:', err)
    });
  }
  onEdit(page: CMSPageListDTO): void {
    console.log('Edit page:', page);
    // Optional: navigate or open a dialog
  }
}
